import { render } from "./RatingComponent.vue?vue&type=template&id=00aaf5f3&scoped=true"
import script from "./RatingComponent.vue?vue&type=script&lang=js"
export * from "./RatingComponent.vue?vue&type=script&lang=js"

import "./RatingComponent.vue?vue&type=style&index=0&id=00aaf5f3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00aaf5f3"]])

export default __exports__